export default "__VITE_ASSET__qHeNQpJQ__"